import React from 'react';

import { useTranslation } from 'react-i18next';

import slideImg1 from '@assets/images/welcome/blitz/onboarding_step1.webp';
import slideImg2 from '@assets/images/welcome/blitz/onboarding_step2.webp';
import slideImg3 from '@assets/images/welcome/blitz/onboarding_step3.webp';

import useIsInIframe from '@hooks/use-is-in-iframe';

import { Button } from '@components/button';

import * as Styled from './blitz-welcome.styles';

type OwnProps = {
	slide: number;
	onClickNext: () => void;
	onClickPrevious: () => void;
};

const BlitzWelcome: React.FC<OwnProps> = ({ slide, onClickNext, onClickPrevious }) => {
	const isInIframe = useIsInIframe();
	const { t } = useTranslation('blitzWelcome');

	return (
		<Styled.Wrapper $isIframe={isInIframe}>
			<Styled.Content>
				<Styled.ContentLeft>
					<Styled.Title>{t(slide === 1 ? 'title1' : slide === 2 ? 'title2' : 'title3')}</Styled.Title>

					<Styled.Text
						dangerouslySetInnerHTML={{
							__html: t(slide === 1 ? 'text1' : slide === 2 ? 'text2' : 'text3')
						}}
					/>

					<Styled.ButtonRow>
						{slide > 1 && (
							<Button minWidth={75} color='dark' onClick={onClickPrevious}>
								{t('main:back')}
							</Button>
						)}
						<Button minWidth={75} color='primary' onClick={onClickNext}>
							{slide > 3 ? t('main:clear') : t('main:next')}
						</Button>
					</Styled.ButtonRow>
				</Styled.ContentLeft>
				<Styled.IntroPic src={t(slide === 1 ? slideImg1 : slide === 2 ? slideImg2 : slideImg3)} alt='intro' />
			</Styled.Content>
		</Styled.Wrapper>
	);
};

export default BlitzWelcome;
